import React from "react";
import InteractiveDemoConsole from "../../universal/InteractiveDemoConsole/InteractiveDemoConsole";

function Project(props) {
    if (props.title === null) {
        return null;
    } else {
        return (
            <div className="project">
                <div className="project_text">
                    <h4>{props.title}</h4>
                    <p>{props.description}</p>
                </div>
                {typeof props.project_code === "string" && props.project_code.trim() !== "" ? (
                    <InteractiveDemoConsole
                        code={props.project_code}
                        title={props.title}
                        theme="default"
                    />
                ) : props.replit_link ? (
                    <div className="replit_embed">
                        <iframe
                            title={`${props.title} embedded project`}
                            frameBorder="0"
                            width="90%"
                            height="300px"
                            src={props.replit_link}
                        />
                    </div>
                ) : null}
            </div>
        )
    }
}

export default Project;